import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6199dd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "second-div" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "jobtype"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 3,
  class: "jobtype font-weight-bold"
}
const _hoisted_7 = {
  key: 4,
  class: "dateofmaster"
}
const _hoisted_8 = { key: 5 }
const _hoisted_9 = {
  key: 0,
  class: "address mb-1"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = {
  key: 1,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { key: 5 }
const _hoisted_18 = {
  key: 2,
  class: "customer"
}
const _hoisted_19 = {
  key: 3,
  class: "summary"
}
const _hoisted_20 = {
  key: 4,
  class: "description"
}
const _hoisted_21 = {
  key: 5,
  class: "location"
}
const _hoisted_22 = {
  key: 6,
  class: "timing"
}
const _hoisted_23 = {
  key: 7,
  class: "timing"
}
const _hoisted_24 = { class: "first-div" }
const _hoisted_25 = ["title"]
const _hoisted_26 = ["title"]
const _hoisted_27 = {
  key: 2,
  class: "fa fa-check-circle icon-botton-right",
  style: {"color":"yellowgreen"},
  title: "Job fully confirmed"
}
const _hoisted_28 = ["title"]
const _hoisted_29 = ["title"]
const _hoisted_30 = {
  key: 5,
  class: "fas fa-pound-sign icon-botton-right",
  style: {"color":"yellow"},
  title: "payment in advance"
}
const _hoisted_31 = ["title"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 0,
  class: "third-div"
}
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "fa-stack duration-badge" }
const _hoisted_36 = {
  key: 1,
  class: "fa-stack-1x duration-badge-number fas fa-times"
}
const _hoisted_37 = ["title"]
const _hoisted_38 = { class: "fa-stack duration-badge" }
const _hoisted_39 = {
  key: 1,
  class: "fa-stack-1x duration-badge-number fas fa-times"
}
const _hoisted_40 = {
  key: 1,
  class: "third-div"
}
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "fa-stack duration-badge" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-circle duration-badge-circle-green" }, null, -1))
const _hoisted_44 = {
  key: 0,
  class: "fa-stack-1x duration-badge-number-green"
}
const _hoisted_45 = {
  key: 1,
  class: "fa-stack-1x duration-badge-number-green fas fa-times"
}
const _hoisted_46 = ["title"]
const _hoisted_47 = { class: "fa-stack duration-badge" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-circle duration-badge-circle-green" }, null, -1))
const _hoisted_49 = {
  key: 0,
  class: "fa-stack-1x duration-badge-number-green"
}
const _hoisted_50 = {
  key: 1,
  class: "fa-stack-1x duration-badge-number-green fas fa-times"
}

import { computed, inject, onMounted, ref, PropType, toRaw } from 'vue';
import { useStore } from 'vuex';
import _get from "lodash/get";
import { SelectOption, Booking, Auditlog, Auditlogvaluechange } from "@/models";
import { getAppointmentcolour } from "@/utilities";
import DxContextMenu from "devextreme-vue/context-menu";
import moment from 'moment-timezone';

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingTemplate',
  props: {
  highlight: { type: String as PropType<string>, default: '' },
  picolour: { type: Boolean as PropType<boolean>, default: true },
  rightclick: { type: Boolean as PropType<boolean>, default: true },
  showdate: { type: Boolean as PropType<boolean>, default: false },
  templateModel: { type: Object as PropType<any>, default: {} },
  showtraveltime: { type: Boolean as PropType<boolean>, default: false },
},
  emits: ['locateBooking', 'showSubJobModal', 'showBookingCancelModal'],
  setup(__props, { emit: __emit }) {

const props = __props;

// Injected properties
const actProperty: any = inject('actProperty');
const emit = __emit;

// Vuex store
const store = useStore();

const cognitoUser = computed(() => store.getters['auth/cognitoUser']);
const dictionary = computed(() => store.getters['dictionary/current']);
const inspectorList = computed(() => store.getters['diary/inspectorlist']);
const email = computed(() => store.getters['auth/email']);
const showbookingswithproblems = computed((): boolean => store.getters['diary/showbookingswithproblems']);
const prepdate = ref('');
const cidate = ref('');
const previousbookinginspector = ref('');


const booking = computed(() => props.templateModel?.appointmentData);
const title = computed(() => {
  let bookingtitle = actProperty.getBookingTitle(booking.value, dictionary.value);
  if (booking.value.jobtype && booking.value.titlenotes) {
    bookingtitle = `${bookingtitle}: ${booking.value.titlenotes}`
  }
  else {
    bookingtitle = `${bookingtitle}`
  }
  return bookingtitle;
});
const paymentAdvanceFlag = computed(() => {
  let paymentAdvanceFlag = false;
  if (booking.value.jobtype === "checkout" || booking.value.jobtype === "soc") {
    paymentAdvanceFlag = booking.value.customer.accountsettings.paymentinadvcosoc;
  } else if (booking.value.jobtype === "inventory" || booking.value.jobtype === "checkin") {
    paymentAdvanceFlag = booking.value.customer.accountsettings.paymentinadvinvci;
  }
  // https://trello.com/c/rSOlSr3W/720-payment-in-advance-logo
  if (paymentAdvanceFlag) {
    let paidFlagArray = booking.value.invoices.map((f) => f?.fees[0]?.paid);
    const allFlagged = paidFlagArray.every((item) => item);
    if (allFlagged) {
      paymentAdvanceFlag = false;
    }
  }
  return paymentAdvanceFlag;
});
const firstlineof = (textdata: string) => {
  let val = "";
  if (textdata) {
    let plaintext = convertToPlain(textdata);
    let lines = plaintext.split("\n");
    if (lines && lines.length)
      val = lines[0];
  }
  return val;
}

const shortfurnished = computed(() => {
  let shortfurnished: string = booking.value?.propertyspec?.furnished;
  switch (shortfurnished) {
    case "Unfurnished":
      shortfurnished = "Unf";
      break;
    case "Part furnished":
      shortfurnished = "Part";
      break;
    case "Fully furnished":
      shortfurnished = "Fur";
      break;
    case "Fully furnished with linen":
      shortfurnished = "FurLin";
      break;
  }
  return shortfurnished;
});

const rightclickoptions = computed(() => {
  let options: SelectOption[] = [];
  if (!booking.value.locked || (booking.value.locked && booking.value.lockedby === email.value)) {
    if (booking.value && props.rightclick) {
      if (booking.value.googleid || booking.value.jobtype === Booking.PERSONAL || booking.value.subtype === Booking.PERSONAL) {
        options = [];
        options.push({
          name: "Delete",
          slug: "Delete",
          icon: "fas fa-times-circle",
        });
      }
      else {
        if (booking.value.subtype) {
          options.push({
            name: `Master with ${booking.value.leadbooking?.inspector?.name}`,
            slug: booking.value.leadbooking?.id,
            date: booking.value.leadbooking?.startdate,
            icon: "far fa-calendar-alt",
          });
        }

        let prepjobpresent = false;
        if (booking.value.subbookings.length) {
          booking.value.subbookings.forEach((s: Booking) => {
            if (s.subtype === "Shared") {
              options.push({
                name: `Shared job with ${s.inspector?.name}`,
                slug: s.id,
                date: s.startdate,
                icon: "far fa-calendar-alt",
              });
            } else if (s.subtype === "Prep") {
              prepjobpresent = true;
              options.push({
                name: `Prep job with ${s.inspector?.name}`,
                slug: s.id,
                date: s.startdate,
                icon: "far fa-calendar-alt",
              });
            } else if (s.subtype === "Key") {
              options.push({
                name: `Key collection ${s.inspector?.name}`,
                slug: s.id,
                date: s.startdate,
                icon: "far fa-calendar-alt",
              });
            } else if (s.subtype === "Revisit") {
              options.push({
                name: `Revisit ${s.inspector?.name}`,
                slug: s.id,
                date: s.startdate,
                icon: "far fa-calendar-alt",
              });
            }
          });
        }

        if (booking.value.subtype != Booking.PREP && !prepjobpresent) {
          options.push({
            name: "Create prep job",
            slug: "Create prep job",
            icon: "fas fa-columns",
          });
        }
        if (booking.value.subtype != Booking.SHARED) {
          options.push({
            name: "Create shared job",
            slug: "Create shared job",
            icon: "fas fa-user-friends",
          });
        }

        if (!booking.value.subtype) {
          options.push({
            name: "Create key collection",
            slug: "Create key collection",
            icon: "fas fa-key",
          });
          options.push({
            name: "Create revisit",
            slug: "Create revisit",
            icon: "fas fa-retweet",
          });
        }

        options.push({
          name: "Delete",
          slug: "Delete",
          icon: "fas fa-times-circle",
        });
      }
    }
  }
  return options;
});

const convertToPlain = (html: string) => {
  var tempDivElement = document.createElement("div");
  tempDivElement.innerHTML = html;
  return tempDivElement.textContent || tempDivElement.innerText || "";
};

const itemClick = (e: any) => {
  if (!booking.value.locked || (booking.value.locked && booking.value.lockedby === email.value)) {
    if (
      e.itemData.name.startsWith("Shared job") ||
      e.itemData.name.startsWith("Prep job") ||
      e.itemData.name.startsWith("Key collection") ||
      e.itemData.name.startsWith("Revisit") ||
      e.itemData.name.startsWith("Master")
    ) {
      emit("locateBooking", {
        bookingid: e.itemData.slug,
        date: e.itemData.date,
      });
    } else if (e.itemData.name === "Create shared job") {
      showSubJobModal(Booking.SHARED);
    } else if (e.itemData.name === "Create prep job") {
      showSubJobModal(Booking.PREP);
    } else if (e.itemData.name === "Create key collection") {
      showSubJobModal(Booking.KEY);
    } else if (e.itemData.name === "Create revisit") {
      showSubJobModal(Booking.REVISIT);
    } else if (e.itemData.name === "Delete") {
      cancelBooking();
    }
  }
};

const showSubJobModal = (subjobtype: string) => {
  emit('showSubJobModal', booking.value, subjobtype);
};

const cancelBooking = () => {
  emit('showBookingCancelModal', booking.value);
}

const issueTitle = computed(() => {
  let findIssueData = actProperty.findLastIssueData(booking.value.auditlogs, 'issued');
  if (booking.value.issued && (findIssueData === null || booking.value.auditlogs.length === 0)) return "Job issued to client";
  let date = moment(findIssueData.datetime).format(
              "DD-MM-YYYY"
            );
  let username = findIssueData.user;
  let title = `Issued - ${date} - ${username}`
  return title;
});


const appointmentstyle = computed(() => {
  if (!props.picolour) return "";
  let style = "";
  if (booking.value.id === props.highlight) {
    style = `background-image: conic-gradient(from var(--border-angle), ${appointmentcolour.value}, ${appointmentcolour.value} 50%, ${appointmentcolour.value}), conic-gradient(from var(--border-angle), transparent 20%, #253746, #eadb40);`;
  } else {
    style = `background: ${appointmentcolour.value};`;
  }
  return style;
});

const appointmentcolour = computed(() => getAppointmentcolour(booking.value, inspectorList.value));

const pischeduler = computed(() => {
  const assignedGroups = _get(
    cognitoUser.value,
    'signInUserSession.accessToken.payload["cognito:groups"]',
    []
  );
  const isDiaryUser = assignedGroups.some((assignedGroup: string) =>
    ["DiaryUser"].includes(assignedGroup)
  );
  return (screen.width <= 760 && isDiaryUser);
});

const skulltitle = computed(() => {
  let title = '';
  if (booking.value.checkoutWithoutPreviousReport) {
    title = 'Previous report not present';
  } else if (booking.value.checkoutWithoutDataentry) {
    if (!booking.value.dataentryreport)
      title = 'Dataentry report is missing';
    else if (booking.value.dataentryreport.dataentrystatus != 'Upload Complete')
      title = 'Dataentry report is not completed by dataentry team';
  }
  return title;
});

const description = computed({
  get: () => {
    var val = booking.value.description;
    if (booking.value.pinotes)
      val = val ? `${val}\n${booking.value.pinotes}` : booking.value.pinotes;
    return val;
  },
  set: (val: string) => {
    booking.value.description = val;
  }
});

onMounted(() => {
  if (booking.value.subtype === Booking.PREP) {
    if (booking.value.leadbooking?.id) {
      cidate.value = booking.value.leadbooking.bookingdate;
    }
  } else if (booking.value.subbookings) {
    booking.value.subbookings.forEach((b: Booking) => {
      if (b.subtype === Booking.PREP) {
        prepdate.value = b.bookingdate;
      }
    });
  }

});

const previousPIDifferent = () => {
  let value = false;
  if (booking.value?.previousbooking?.id && booking.value.previousbooking.inspector?.id != booking.value.inspector?.id) {
    if (booking.value?.previousbooking.jobtype === 'checkout' || booking.value?.previousbooking.jobtype === 'soc' || booking.value?.previousbooking.subtype === 'Prep') {
      if (booking.value?.internaljobtype === 'Inv CI - off upload' || booking.value?.internaljobtype === 'Check-In - off ACT report' || booking.value?.internaljobtype === 'Check-In - off upload') {
        value = true;
        previousbookinginspector.value = booking?.value?.previousbooking?.inspector?.name;
      }
    }
  }
  else if (booking.value?.subbookings && booking.value?.subbookings.length > 0) {
    let prep = booking.value?.subbookings.find((b) => b.subtype === 'Prep');
    let keypickup = booking.value?.subbookings.find((b) => b.subtype === 'Key');
    let revisit = booking.value?.subbookings.find((b) => b.subtype === 'Revisit');
    if (prep?.id && prep.inspector?.id != booking.value.inspector?.id) {
      value = true;
      previousbookinginspector.value = prep.inspector.name;
    }
    else if (keypickup?.id && keypickup.inspector?.id != booking.value.inspector?.id) {
      value = true;
      previousbookinginspector.value = keypickup.inspector.name;
    }
    else if (revisit?.id && revisit.inspector?.id != booking.value.inspector?.id) {
      value = true;
      previousbookinginspector.value = revisit.inspector.name;
    }
  }
  else if (booking.value?.leadbooking?.id && booking.value?.inspector?.id != booking.value?.leadbooking?.inspector?.id) {
    value = true;
    previousbookinginspector.value = booking.value?.leadbooking?.inspector?.name;
  }
  
  return value;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container booking", {
    'white-border': booking.value.appointmenttimeoutsidebooking,
    selectedbooking: booking.value.id === __props.highlight,
    allday: booking.value.isAllDay,
    hide: showbookingswithproblems.value && (!booking.value.bookingrequiringpreviousreport || (booking.value.basereport && booking.value.basereport.id && booking.value.basereport.firstexportedbywithcutoff && booking.value.targetreport && booking.value.targetreport && booking.value.targetreport.id))
  }]),
    id: 'appointment-box-' + booking.value.id,
    style: _normalizeStyle(appointmentstyle.value)
  }, [
    _createElementVNode("div", _hoisted_2, [
      (__props.showdate)
        ? (_openBlock(), _createElementBlock("h6", _hoisted_3, _toDisplayString(booking.value.bookingdate), 1))
        : _createCommentVNode("", true),
      (booking.value.jobtype === 'Personal')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h6", null, _toDisplayString(firstlineof(booking.value.summary)), 1)
          ]))
        : _createCommentVNode("", true),
      (booking.value.subtype === 'Personal')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(description.value), 1))
        : (booking.value.jobtype)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(), _createElementBlock("h5", {
                key: booking.value.updatedAt
              }, _toDisplayString(title.value), 1))
            ]))
          : _createCommentVNode("", true),
      (booking.value.subtype === 'Key')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Date of master job: " + _toDisplayString(booking.value.leadbooking.bookingdate), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (booking.value.addressPreviewLine1 || booking.value.addressPreviewLine2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createTextVNode(_toDisplayString(booking.value.address.postcode) + " ", 1),
                  _hoisted_10,
                  _createTextVNode(_toDisplayString(booking.value.addressPreviewLine1), 1)
                ]))
              : _createCommentVNode("", true),
            (booking.value.propertyspec)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (booking.value.propertyspec.bedrooms)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(booking.value.propertyspec.bedrooms) + " Beds ", 1))
                    : _createCommentVNode("", true),
                  (booking.value.propertyspec.bathrooms)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(booking.value.propertyspec.bathrooms) + " Baths ", 1))
                    : _createCommentVNode("", true),
                  (booking.value.propertyspec.receptions)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(booking.value.propertyspec.receptions) + " Recs ", 1))
                    : _createCommentVNode("", true),
                  (booking.value.propertyspec.sqft)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(booking.value.propertyspec.sqft) + " Sq Ft ", 1))
                    : _createCommentVNode("", true),
                  (booking.value.propertyspec.propertytype)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(booking.value.propertyspec.propertytype), 1))
                    : _createCommentVNode("", true),
                  (booking.value.propertyspec.furnished)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(shortfurnished.value), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (booking.value.customer &&
    (booking.value.customer.companyName || booking.value.customer.branchName)
    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(booking.value.customer.companyName) + " - " + _toDisplayString(booking.value.customer.branchName), 1))
              : _createCommentVNode("", true),
            (booking.value.subtype != 'Personal' && booking.value.summary)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(booking.value.summary), 1))
              : _createCommentVNode("", true),
            (booking.value.subtype != 'Personal' && booking.value.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(convertToPlain(booking.value.description)), 1))
              : _createCommentVNode("", true),
            (booking.value.location)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(booking.value.location), 1))
              : _createCommentVNode("", true),
            (booking.value.isAllDay)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, "All day"))
              : ((booking.value.startdate || booking.value.enddate))
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(booking.value.starttime) + " to " + _toDisplayString(booking.value.endtime), 1))
                : _createCommentVNode("", true)
          ])),
      (!pischeduler.value)
        ? (_openBlock(), _createBlock(_unref(DxContextMenu), {
            key: 6,
            "data-source": rightclickoptions.value,
            displayExpr: "name",
            width: 200,
            target: '#appointment-box-' + booking.value.id,
            onItemClick: itemClick
          }, null, 8, ["data-source", "target"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_24, [
      (booking.value.checkoutWithoutDataentry)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "fas fa-skull-crossbones icon-botton-right",
            style: {"color":"yellow"},
            title: skulltitle.value
          }, null, 8, _hoisted_25))
        : _createCommentVNode("", true),
      (booking.value.provisional)
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: "fa fa-exclamation-circle icon-botton-right",
            style: {"color":"yellow"},
            title: `Provisional booking: ${booking.value.provisionalnotes}`
          }, null, 8, _hoisted_26))
        : _createCommentVNode("", true),
      (!booking.value.issued && !booking.value.provisional && booking.value.tenantattending != 'unsure' && booking.value.confirmaccess)
        ? (_openBlock(), _createElementBlock("i", _hoisted_27))
        : _createCommentVNode("", true),
      (booking.value.issued)
        ? (_openBlock(), _createElementBlock("i", {
            key: 3,
            class: "fa fa-star icon-botton-right",
            style: {"color":"yellow"},
            title: issueTitle.value
          }, null, 8, _hoisted_28))
        : _createCommentVNode("", true),
      (booking.value.locked)
        ? (_openBlock(), _createElementBlock("i", {
            key: 4,
            class: "fas fa-lock icon-botton-right",
            style: {"color":"yellow"},
            title: booking.value.lockedby
          }, null, 8, _hoisted_29))
        : _createCommentVNode("", true),
      (paymentAdvanceFlag.value)
        ? (_openBlock(), _createElementBlock("i", _hoisted_30))
        : _createCommentVNode("", true),
      (previousPIDifferent())
        ? (_openBlock(), _createElementBlock("i", {
            key: 6,
            class: "fas fa-sync-alt icon-botton-right",
            style: {"color":"yellow"},
            title: previousbookinginspector.value
          }, null, 8, _hoisted_31))
        : _createCommentVNode("", true)
    ]),
    (__props.showtraveltime && booking.value.jobtype !== 'Personal' && !booking.value.googleid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          (booking.value.fromDurationSecs >= 0 || booking.value.toDurationSecs >= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                (booking.value.toDurationSecs >= 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: {"position":"fixed","top":"0","right":"0"},
                      title: booking.value.toDurationText
                    }, [
                      _createElementVNode("span", _hoisted_35, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fa fa-circle duration-badge-circle", { 'top-badge-circle': booking.value.topTo }])
                        }, null, 2),
                        (booking.value.toDurationSecs < 5941)
                          ? (_openBlock(), _createElementBlock("strong", {
                              key: 0,
                              class: _normalizeClass(["fa-stack-1x duration-badge-number", { 'top-badge-text': booking.value.topTo }])
                            }, _toDisplayString(booking.value.toDurationMins ? booking.value.toDurationMins : '0'), 3))
                          : (_openBlock(), _createElementBlock("i", _hoisted_36))
                      ])
                    ], 8, _hoisted_34))
                  : _createCommentVNode("", true),
                (booking.value.fromDurationSecs >= 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      style: {"position":"fixed","bottom":"0","left":"0"},
                      title: booking.value.fromDurationText
                    }, [
                      _createElementVNode("span", _hoisted_38, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fa fa-circle duration-badge-circle", { 'top-badge-circle': booking.value.topFrom }])
                        }, null, 2),
                        (booking.value.fromDurationSecs < 5941)
                          ? (_openBlock(), _createElementBlock("strong", {
                              key: 0,
                              class: _normalizeClass(["fa-stack-1x duration-badge-number", { 'top-badge-text': booking.value.topFrom }])
                            }, _toDisplayString(booking.value.fromDurationMins ? booking.value.fromDurationMins : '0'), 3))
                          : (_openBlock(), _createElementBlock("i", _hoisted_39))
                      ])
                    ], 8, _hoisted_37))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          ((booking.value.traveltime.from > 0 || booking.value.traveltime.to > 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                (booking.value.traveltime.from > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: {"position":"fixed","top":"0","right":"0"},
                      title: booking.value.traveltime.fromText
                    }, [
                      _createElementVNode("span", _hoisted_42, [
                        _hoisted_43,
                        (booking.value.traveltime.from < 5941)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_44, _toDisplayString(booking.value.traveltime.fromMins ? booking.value.traveltime.fromMins : '0'), 1))
                          : (_openBlock(), _createElementBlock("i", _hoisted_45))
                      ])
                    ], 8, _hoisted_41))
                  : _createCommentVNode("", true),
                (booking.value.traveltime.to > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      style: {"position":"fixed","bottom":"0","left":"0"},
                      title: booking.value.traveltime.toText
                    }, [
                      _createElementVNode("span", _hoisted_47, [
                        _hoisted_48,
                        (booking.value.traveltime.to < 5941)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_49, _toDisplayString(booking.value.traveltime.toMins ? booking.value.traveltime.toMins : '0'), 1))
                          : (_openBlock(), _createElementBlock("i", _hoisted_50))
                      ])
                    ], 8, _hoisted_46))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}
}

})